/* BIRDLINE — cart controller
   Powers both the cart PAGE and the slide-out DRAWER:
   quantity steppers, remove, upsell add, drawer open/close, AJAX add-to-cart.
   Drawer markup is a section so it can be re-rendered via the Section Rendering API. */
(function () {
  var DRAWER_SECTION = 'birdline-cart-drawer';
  var returnFocus = null;

  function drawer() { return document.querySelector('[data-bl-drawer]'); }

  function announce(message, isError) {
    var status = document.querySelector('[data-bl-cart-status]');
    if (!status) {
      status = document.createElement('div');
      status.setAttribute('data-bl-cart-status', '');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
      status.style.cssText = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0';
      document.body.appendChild(status);
    }
    status.setAttribute('role', isError ? 'alert' : 'status');
    status.textContent = '';
    window.setTimeout(function () { status.textContent = message; }, 10);
  }

  function jsonResponse(response) {
    return response.json().then(function (data) {
      if (!response.ok) {
        throw new Error(data.description || data.message || 'The cart could not be updated.');
      }
      return data;
    });
  }

  function openDrawer(preserveReturnFocus) {
    var d = drawer();
    if (!d) return;
    if (!preserveReturnFocus) returnFocus = document.activeElement;
    d.classList.add('is-open');
    d.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    var panel = d.querySelector('.bl-drawer__panel');
    var initialFocus = d.querySelector('[data-bl-drawer-close]') || panel;
    if (initialFocus) window.setTimeout(function () { initialFocus.focus(); }, 0);
  }

  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (returnFocus && document.contains(returnFocus)) returnFocus.focus();
    returnFocus = null;
  }

  /* ---- the ladder ---------------------------------------------------------
       shipState() used to read a flag off the shipping row. It is gone: the
       ladder now has two rungs and two tiers, and window.BL.ladderState() is
       the only thing in this theme permitted to answer a question about price
       or thresholds. Everything below reads that one object.

       The drawer is re-rendered wholesale on every cart mutation, and
       bl-tier-cart.liquid re-renders the authoritative tier map with it, so
       reading ladderState() after a refresh always reflects the new cart. */
    function ladder() {
      return (window.BL && window.BL.ladderState) ? window.BL.ladderState() : null;
    }

    /* Fire once per rung per session, and reset the flag when the cart drops
       back below that rung. Without the reset, removing and re-adding an item
       retriggers the celebration forever; without the flag, every quantity tap
       past the threshold sets birds off again. QA case 14 is exactly this. */
    var RUNG_KEY = 'birdline:ladder:rung';
    function rungFired(n) {
      try { return sessionStorage.getItem(RUNG_KEY + n) === '1'; } catch (e) { return false; }
    }
    function setRung(n, on) {
      try {
        if (on) sessionStorage.setItem(RUNG_KEY + n, '1');
        else sessionStorage.removeItem(RUNG_KEY + n);
      } catch (e) {}
    }

    /* Named blTrack, not track: this file already declares a `track(btn)`
       helper for the upsell carousel further down, and a function declaration
       later in the same scope wins. Calling it with a string threw
       "btn.closest is not a function" and took the whole ladder down with it. */
    function blTrack(name, params) {
      /* Analytics must never be able to break pricing or the celebration.
         A thrown tag manager is a reporting gap, not a broken cart. */
      try {
        if (window.BL && window.BL.track) window.BL.track(name, params || {});
      } catch (e) {}
    }

    /* Rung 1: the flock. Rung 2 never gets particles — it is glow only. */
    function celebrate() {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var style = (window.BL && window.BL.celebration && window.BL.celebration.ship) || 'confetti';
      if (reduce || style === 'none') return;

      var button = document.querySelector('.bl-drawer .bl-checkout');
      if (!button) return;
      var form = button.closest('form') || button.parentNode;
      if (!form) return;

      button.classList.remove('is-celebrating');
      void button.offsetWidth;
      button.classList.add('is-celebrating');
      window.setTimeout(function () { button.classList.remove('is-celebrating'); }, 950);

      if (!form.animate) return;

      /* The birds are the default. The original confetti is left intact and
         reachable from Theme settings so this reverts with a toggle rather
         than a rollback. */
      if (style === 'birds' && window.BL && window.BL.flyBirds) {
        window.BL.flyBirds({ button: button, host: form });
        return;
      }
      confetti(form, button);
    }

    /* Rung 2 deliberately has no celebrate() twin: it is glow only, applied in
       runLadder() as a state. Two bursts back to back would read as a slot
       machine; this is a change you notice, not an event that interrupts you. */

    function confetti(form, button) {
      var old = form.querySelector('.bl-confetti');
      if (old) old.remove();

      var layer = document.createElement('div');
      layer.className = 'bl-confetti';
      layer.setAttribute('aria-hidden', 'true');

      // Fire from the middle of the checkout button, not the middle of the form,
      // so the burst reads as coming out of the thing we want them to press.
      var fr = form.getBoundingClientRect();
      var br = button.getBoundingClientRect();
      var ox = br.left - fr.left + br.width / 2;
      var oy = br.top - fr.top + br.height / 2;
      var width = form.offsetWidth || 380;

      var glow = document.createElement('span');
      glow.className = 'bl-confetti__glow';
      glow.style.left = ox + 'px';
      glow.style.top = oy + 'px';
      layer.appendChild(glow);

      var colors = ['#C85A1A', '#E0762E', '#C9A227', '#F6F1E7', '#8FA98F', '#1F3A2A'];
      var shapes = ['', 'is-round', 'is-strip'];
      var pieces = 58;

      for (var i = 0; i < pieces; i++) {
        var bit = document.createElement('i');
        bit.className = shapes[i % shapes.length];
        bit.style.background = colors[i % colors.length];
        bit.style.left = ox + 'px';
        bit.style.top = oy + 'px';
        layer.appendChild(bit);
      }
      form.appendChild(layer);

      glow.animate(
        [
          { transform: 'scale(0.35)', opacity: 0, offset: 0 },
          { transform: 'scale(0.95)', opacity: 1, offset: 0.22 },
          { transform: 'scale(1.25)', opacity: 0, offset: 1 }
        ],
        { duration: 1000, easing: 'cubic-bezier(0.15, 0.7, 0.3, 1)', fill: 'forwards' }
      );

      Array.prototype.forEach.call(layer.querySelectorAll('i'), function (bit, i) {
        var side = i % 2 ? 1 : -1;
        var dx = side * (0.12 + Math.random() * 0.88) * width * 0.85;
        var rise = 85 + Math.random() * 105;
        var fall = 150 + Math.random() * 150;
        var spin = (Math.random() - 0.5) * 1500;
        var delay = Math.random() * 150;
        bit.animate(
          [
            { transform: 'translate(-50%, -50%) rotate(0deg) scale(0.6)', opacity: 0, offset: 0 },
            { transform: 'translate(calc(-50% + ' + dx * 0.3 + 'px), calc(-50% + ' + -rise * 0.85 + 'px)) rotate(' + spin * 0.3 + 'deg) scale(1)', opacity: 1, offset: 0.18 },
            { transform: 'translate(calc(-50% + ' + dx * 0.7 + 'px), calc(-50% + ' + -rise + 'px)) rotate(' + spin * 0.6 + 'deg) scale(1)', opacity: 1, offset: 0.45 },
            { transform: 'translate(calc(-50% + ' + dx + 'px), calc(-50% + ' + fall + 'px)) rotate(' + spin + 'deg) scale(0.9)', opacity: 0, offset: 1 }
          ],
          { duration: 1500 + Math.random() * 650, delay: delay, easing: 'cubic-bezier(0.16, 0.72, 0.28, 1)', fill: 'forwards' }
        );
      });

      window.setTimeout(function () { if (layer.parentNode) layer.remove(); }, 2500);
    }

    /* One place decides what, if anything, to celebrate. Call it after the
       drawer has re-rendered — the fresh tier map is in the DOM by then, so
       ladderState() already describes the new cart.

       `before` is the state captured prior to the re-render. Passing it in
       rather than diffing a global keeps this honest across the two entry
       points (drawer refresh and full page load). */
    /* Rung 2's payoff is a button, not a feeling, so its flock is aimed at that
       button rather than scattered upward. The scroll first is part of the
       gesture: Shop All sits at the top of the drawer and the shopper is looking
       at the bottom of it, so the birds would otherwise fly to somewhere off
       screen. Scroll, let it settle, then fly. */
    function celebrateFieldSet() {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var style = (window.BL && window.BL.celebration && window.BL.celebration.set) || 'birds';
      if (reduce || style === 'none') return;
      if (style !== 'birds') { celebrate(); return; }
      if (!window.BL || !window.BL.flyBirdsTo) return;

      var d = drawer();
      if (!d || !d.classList.contains('is-open')) return;

      var target = d.querySelector('.bl-shopall');
      var origin = d.querySelector('.bl-checkout');
      if (!target || !origin) return;

      var scroller = d.querySelector('.bl-drawer__scroll');
      if (scroller && scroller.scrollTop > 0) {
        try { scroller.scrollTo({ top: 0, behavior: 'smooth' }); }
        catch (e) { scroller.scrollTop = 0; }
      }

      setTimeout(function () {
        window.BL.flyBirdsTo({ from: origin, to: target });
      }, 260);
    }

    function runLadder(before) {
      var st = ladder();
      if (!st || !st.enabled) return;

      /* Reset the guards the moment the cart falls back below a rung, so the
         next genuine crossing celebrates again — and only then. */
      if (!st.shipUnlocked) setRung(1, false);
      if (!st.setUnlocked) setRung(2, false);

      /* Prompts. "Shown" is the ask being displayed, once per session. */
      if (st.tees > 0 && !st.shipUnlocked && !rungFired('1shown')) {
        setRung('1shown', true);
        blTrack('ladder_rung1_shown', { tees: st.tees, needed: st.shipRemaining });
      }
      if (st.shipUnlocked && !st.setUnlocked && !rungFired('2shown')) {
        setRung('2shown', true);
        blTrack('ladder_rung2_shown', { tees: st.tees, needed: st.setRemaining });
      }

      /* A crossing is a false -> true transition we actually observed. `before`
         is null on a page load, which is deliberate: arriving on a page with an
         already-unlocked cart is a state, not an event, so it must not
         celebrate. Only a mutation that happened in front of the shopper does. */
      var crossedShip = before && before.shipUnlocked === false && st.shipUnlocked;
      var crossedSet = before && before.setUnlocked === false && st.setUnlocked;

      /* Rung 1 crossed: the flock. */
      if (crossedShip && !rungFired(1)) {
        setRung(1, true);
        blTrack('ladder_rung1_cleared', { tees: st.tees });
        celebrate();
      }

      /* Rung 2 crossed: the event fires once, and the flock flies to Shop All. */
      if (crossedSet && !rungFired(2)) {
        setRung(2, true);
        blTrack('ladder_rung2_taken', {
          tees: st.tees,
          tier: lastAdded.tier || null,
          handle: lastAdded.handle || null
        });
        celebrateFieldSet();
      }

      /* Repaint here, not on a DOM observer. This runs immediately after the
         drawer's HTML has been swapped in, which is the one moment we can be
         certain the tier map on the page describes the cart that now exists.
         An observer firing on the same mutation races the swap and can paint
         from the previous map, which puts full prices under a Field Set meter. */
      if (window.BL && window.BL.paintLadder) window.BL.paintLadder();

      /* The glow is a state, not an event: it applies whenever the cart
         qualifies, including on a fresh page load, and lifts when it stops. */
      document.querySelectorAll('.bl-ship').forEach(function (el) {
        el.classList.toggle('is-fieldset', !!st.setUnlocked);
      });
    }

    /* What the shopper most recently added, so ladder_rung2_taken can name the
       product that got them over the line rather than reporting an anonymous
       threshold crossing. */
    var lastAdded = {};

    function upsellSignature(root) {
      if (!root) return '';
      var adds = root.querySelectorAll('[data-bl-add]');
      var out = [];
      var head = root.querySelector('.bl-xs__title, .bl-upsell__title');
      if (head) out.push(head.textContent.trim());
      for (var i = 0; i < adds.length; i++) out.push(adds[i].getAttribute('data-bl-add'));
      return out.join('|');
    }

    function refreshDrawer(then) {
      return fetch('/?sections=' + DRAWER_SECTION)
        .then(jsonResponse)
        .then(function (data) {
          var html = data[DRAWER_SECTION];
          if (!html) return;
          var host = document.querySelector('[data-bl-drawer-host]');
          if (!host) return;
                  var wasOpen = drawer() && drawer().classList.contains('is-open');
                  var ladderBefore = ladder();

                  // A quantity tap re-renders the whole drawer. The upsell almost never
                  // changes with it, and throwing its <img> tags away only to insert
                  // identical ones makes the tiles blink on every +/- press -- very
                  // visible on a phone. Keep the live node when the same products return.
                  var keptUpsell = host.querySelector('.bl-xs, .bl-upsell');
                  var keptSig = upsellSignature(keptUpsell);

                  host.innerHTML = html;

                  var freshUpsell = host.querySelector('.bl-xs, .bl-upsell');
                  if (keptUpsell && freshUpsell && keptSig && keptSig === upsellSignature(freshUpsell)) {
                    freshUpsell.parentNode.replaceChild(keptUpsell, freshUpsell);
                  }

                  if (wasOpen) openDrawer(true);
                  runLadder(ladderBefore);
                  if (then) then();
        })
      .catch(function (error) {
        announce(error.message, true);
      });
  }

  function updateCartCounts(count) {
    document.querySelectorAll('.bl-announce__count, [data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
    document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      el.classList.toggle('hidden', count < 1);
      var bubble = el.closest('.cart-bubble');
      if (bubble) bubble.classList.toggle('visually-hidden', count < 1);
    });
  }

  function change(line, quantity, isPage) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: line, quantity: quantity })
    })
      .then(jsonResponse)
      .then(function (cart) {
        updateCartCounts(cart.item_count);
        if (isPage) {
          window.location.reload();
        } else {
          refreshDrawer();
        }
        announce('Cart updated.');
      })
      .catch(function (error) {
        announce(error.message, true);
      });
  }

  function addVariant(id, openAfter) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(jsonResponse)
      .then(function () {
        return fetch('/cart.js').then(jsonResponse);
      })
      .then(function (cart) {
        updateCartCounts(cart.item_count);
        if (document.body.classList.contains('bl-on-cart-page')) {
          window.location.reload();
        } else {
          refreshDrawer(openAfter ? openDrawer : null);
        }
        announce('Item added to cart.');
      })
      .catch(function (error) {
        announce(error.message, true);
      });
  }

  // Quick View owns its add request, then asks the shared cart controller to
  // synchronize every cart surface. Without this bridge Shopify accepted the
  // item, but the header count and slide-out drawer stayed stale.
  document.addEventListener('cart:refresh', function () {
    fetch('/cart.js')
      .then(jsonResponse)
      .then(function (cart) {
        updateCartCounts(cart.item_count);

        // A native <dialog> remains in the browser's top layer, so close Quick
        // View before opening the drawer or the refreshed cart is hidden behind
        // the modal even though it is technically open.
        var quickView = document.querySelector('[data-bl-qv-dialog][open]');
        if (quickView && typeof quickView.close === 'function') quickView.close();

        if (document.body.classList.contains('bl-on-cart-page')) {
          window.location.reload();
        } else {
          // Open immediately, then replace the drawer contents when Shopify's
          // section response arrives. This removes the noticeable dead pause.
          openDrawer();
          refreshDrawer();
        }
        announce('Item added to cart.');
      })
      .catch(function (error) {
        announce(error.message, true);
      });
  });

  document.addEventListener('click', function (e) {
    // open drawer from any cart link/icon (unless already on the cart page)
    var cartLink = e.target.closest('a[href$="/cart"], a[href*="/cart?"], [data-bl-open-cart]');

    // A cart link INSIDE the drawer -- "View and edit cart" -- must NAVIGATE to
    // the cart page. It matched the selector above, so it was preventDefault'd
    // and merely re-opened an already-open drawer: the link looked dead.
    if (cartLink && cartLink.closest('[data-bl-drawer]')) return;

    if (cartLink && !document.body.classList.contains('bl-on-cart-page') && drawer()) {
      e.preventDefault();
      openDrawer();
      return;
    }

    if (e.target.closest('[data-bl-drawer-close]')) { e.preventDefault(); closeDrawer(); return; }
    var d = drawer();
    if (d && e.target === d) { closeDrawer(); return; }

    // quantity + / − and remove
    var step = e.target.closest('[data-bl-qty]');
    if (step) {
      e.preventDefault();
      var line = step.getAttribute('data-bl-line');
      var next = Number(step.getAttribute('data-bl-qty'));
      change(line, next, step.hasAttribute('data-bl-page'));
      return;
    }
    var rm = e.target.closest('[data-bl-remove]');
    if (rm) {
      e.preventDefault();
      change(rm.getAttribute('data-bl-remove'), 0, rm.hasAttribute('data-bl-page'));
      return;
    }

    // Shop All — the rung-2 payoff. Tracked, then allowed to navigate.
    var shopAll = e.target.closest('[data-bl-shopall]');
    if (shopAll) {
      var sa = ladder();
      blTrack('shopall_click', { tees: sa ? sa.tees : 0, surface: 'drawer' });
      return;
    }

    // upsell add
    var add = e.target.closest('[data-bl-add]');
    if (add) {
      e.preventDefault();

      /* Remember what they added so ladder_rung2_taken can name the product
         that took them over the line. Read off the element rather than looked
         up, because the drawer may re-render before the event fires. */
      lastAdded = {
        tier: add.getAttribute('data-bl-tier') || null,
        handle: add.getAttribute('data-bl-handle') || null
      };

      /* An add made from the collection grid while Field Set pricing is live
         is a different intent from an add made in the drawer, and is the event
         that tells us whether the grid's tier pricing is doing any work. */
      var gridState = ladder();
      if (gridState && gridState.setUnlocked && add.closest('[data-bl-grid], .bl-card')) {
        blTrack('collection_fieldset_add', {
          tier: lastAdded.tier,
          handle: lastAdded.handle,
          tees: gridState.tees
        });
      }

      add.disabled = true;
      add.textContent = 'Adding…';
      addVariant(add.getAttribute('data-bl-add'), true).finally(function () {
        add.disabled = false;
      });
      return;
    }
  });

  /* What the cart looked like at the moment they committed. This is the number
     that tells us whether the ladder actually moved units, so it fires on the
     real checkout submit rather than on any button that looks like one. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action$="/cart"], #BlDrawerForm');
    if (!form) return;
    var st = ladder();
    if (!st) return;
    var byTier = st.byTier || {};
    blTrack('ladder_units_at_checkout', {
      tees: st.tees,
      sig_units: byTier.signature || 0,
      evd_units: byTier.everyday || 0,
      ship_unlocked: st.shipUnlocked,
      set_unlocked: st.setUnlocked
    });
  }, true);

  document.addEventListener('keydown', function (e) {
    var d = drawer();
    if (!d || !d.classList.contains('is-open')) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      closeDrawer();
      return;
    }
    if (e.key !== 'Tab') return;
    var focusable = d.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  // typed quantity input
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-bl-qty-input]');
    if (!input) return;
    var v = Math.max(0, parseInt(input.value, 10) || 0);
    change(input.getAttribute('data-bl-line'), v, input.hasAttribute('data-bl-page'));
  });

  // AJAX add-to-cart so the drawer slides out instead of a page jump
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('#BlProductForm, #BlGcForm');
    if (!form || !drawer()) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    var formData = new FormData(form);
    var selectedVariantId = form.getAttribute('data-bl-current-variant-id');

    // The Birdline PDP resolves an exact option tuple and stores the resulting
    // Shopify variant id on the form. Shopify preview/product-form scripts can
    // clear the generated hidden input after initial paint, so make the cart
    // payload authoritative here as well instead of trusting stale form state.
    if (selectedVariantId) {
      formData.set('id', selectedVariantId);
      var variantInput = form.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.value = selectedVariantId;
        variantInput.setAttribute('value', selectedVariantId);
      }
    }
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(jsonResponse)
      .then(function () { return fetch('/cart.js').then(jsonResponse); })
      .then(function (cart) {
        updateCartCounts(cart.item_count);
        refreshDrawer(openDrawer);
      })
      .catch(function (error) {
        announce(error.message, true);
      })
      .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  });

  // ---- upsell carousel (cart page): ‹ › arrows scroll one card at a time ----
  function track(btn) {
    var wrap = btn.closest('.bl-upsell__carousel');
    return wrap ? wrap.querySelector('[data-bl-carousel]') : null;
  }
  function step(list) {
    var card = list.querySelector('.bl-upsell__card');
    return card ? card.getBoundingClientRect().width + 14 : list.clientWidth;
  }
  function syncArrows(list) {
    var wrap = list.closest('.bl-upsell__carousel');
    if (!wrap) return;
    var max = list.scrollWidth - list.clientWidth - 1;
    var prev = wrap.querySelector('[data-bl-carousel-prev]');
    var next = wrap.querySelector('[data-bl-carousel-next]');
    // Hide both arrows outright when everything already fits on screen.
    var overflows = max > 0;
    if (prev) { prev.hidden = !overflows; prev.disabled = list.scrollLeft <= 0; }
    if (next) { next.hidden = !overflows; next.disabled = list.scrollLeft >= max; }

    // Dots track the leading card so they mean something rather than decorate.
    var dots = wrap.parentElement && wrap.parentElement.querySelector('[data-bl-dots]');
    if (!dots) return;
    var cards = list.querySelectorAll('.bl-upsell__card');
    var active = 0, best = Infinity;
    for (var i = 0; i < cards.length; i++) {
      var d = Math.abs(cards[i].offsetLeft - list.scrollLeft);
      if (d < best) { best = d; active = i; }
    }
    dots.querySelectorAll('.bl-upsell__dot').forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === active);
    });
  }

  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-bl-carousel-prev]');
    var next = e.target.closest('[data-bl-carousel-next]');
    var btn = prev || next;
    if (!btn) return;
    var list = track(btn);
    if (!list) return;
    list.scrollBy({ left: prev ? -step(list) : step(list), behavior: 'smooth' });
  });

  function initCarousels() {
    document.querySelectorAll('[data-bl-carousel]').forEach(function (list) {
      if (list.dataset.blBound) return;
      list.dataset.blBound = '1';
      list.addEventListener('scroll', function () { syncArrows(list); });
      syncArrows(list);
    });
  }
  document.addEventListener('DOMContentLoaded', initCarousels);
  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-bl-carousel]').forEach(syncArrows);
  });
  initCarousels();

  /* A page that loads already past a rung must not celebrate — it only needs
     the state to be right. runLadder with no `before` does exactly that: the
     prompts and the rung-2 glow apply, the flock does not fly. */
  function primeLadder() { runLadder(null); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', primeLadder);
  } else {
    primeLadder();
  }
  document.addEventListener('bl:ladder', primeLadder);
})();

/* ---------------------------------------------------------------------------
   Upsell image lightbox
   The magnifier on an upsell card opens the product photo large. It is bound by
   delegation because the drawer re-renders from ?sections= after every cart
   mutation, which throws away any directly-attached listeners.
   --------------------------------------------------------------------------- */
(function () {
  var OVERLAY_ID = 'bl-zoom-overlay';

  function close() {
    var el = document.getElementById(OVERLAY_ID);
    if (el) el.remove();
    document.removeEventListener('keydown', onKey);
  }

  function onKey(e) {
    if (e.key === 'Escape') close();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bl-zoom-src]');
    if (!btn) return;
    // the card is a link; without this the click navigates instead of zooming
    e.preventDefault();
    e.stopPropagation();

    close();
    var overlay = document.createElement('div');
    overlay.id = OVERLAY_ID;
    overlay.className = 'bl-zoom';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', btn.getAttribute('data-bl-zoom-alt') || 'Product image');

    var fig = document.createElement('figure');
    fig.className = 'bl-zoom__fig';

    var img = document.createElement('img');
    img.src = btn.getAttribute('data-bl-zoom-src');
    img.alt = btn.getAttribute('data-bl-zoom-alt') || '';

    var cap = document.createElement('figcaption');
    cap.textContent = btn.getAttribute('data-bl-zoom-alt') || '';

    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'bl-zoom__close';
    x.setAttribute('aria-label', 'Close');
    x.innerHTML = '&times;';

    fig.appendChild(img);
    fig.appendChild(cap);
    overlay.appendChild(x);
    overlay.appendChild(fig);
    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (ev) {
      if (ev.target === overlay || ev.target === x) close();
    });
        document.addEventListener('keydown', onKey);
        x.focus();
      });

      
    })();

/* ===== BL_CART_BIRD ==============================================
   A count that just appears is a missed moment. When the number goes up the
   bird launches out of the cart, flaps across, and settles on the rim beside
   it. The count stays a plain disc -- it has to stay readable, and every
   attempt to draw a bird around a number turned the number to mush. */
(function () {
  var PERCH = "data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 44 40'%3E%3Cg fill='%23C85A1A'%3E%3Cpath d='M25 3a6 6 0 0 0-5.7 7.9C15 13.2 12 17.6 12 22.8c0 4.1 1.9 7.7 4.9 9.9L14 37h14l-2.6-4.2c3.1-2.2 5.1-5.9 5.1-10 0-3.5-1.5-6.7-3.9-8.9A6 6 0 0 0 25 3z'/%3E%3Cpath d='M19.5 8.6 12 10.4l7.5 2.2z'/%3E%3Cpath d='M30 24c3.5 1.6 6.6 5 9 10-4.6-2.4-8.6-3.6-12-3.6z'/%3E%3C/g%3E%3C/svg%3E";
  var FLY = "data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 62 46'%3E%3Cg fill='%23C85A1A'%3E%3Ccircle cx='30' cy='20' r='6'/%3E%3Cpath d='M24 21 17 23l7 2z'/%3E%3Cellipse cx='31' cy='30' rx='6.5' ry='9'/%3E%3Cpath d='M27 27C19 25 9 24 0 25c6 6 12 10 18 13 3.6 1.8 6.8 2.8 9.4 3.2z'/%3E%3Cpath d='M35 27c8-2 18-3 27-2-6 6-12 10-18 13-3.6 1.8-6.8 2.8-9.4 3.2z'/%3E%3C/g%3E%3C/svg%3E";

  function mount() {
    var icon = document.querySelector('.header-actions__cart-icon');
    if (!icon) return null;
    var found = icon.querySelector('.bl-cartbird');
    if (found) return found;
    var wrap = document.createElement('span');
    wrap.className = 'bl-cartbird';
    wrap.setAttribute('aria-hidden', 'true');
    var f = document.createElement('span');
    f.className = 'bl-cartbird__fly';
    f.style.backgroundImage = 'url("' + FLY + '")';
    var p = document.createElement('span');
    p.className = 'bl-cartbird__perch';
    p.style.backgroundImage = 'url("' + PERCH + '")';
    wrap.appendChild(f);
    wrap.appendChild(p);
    icon.appendChild(wrap);
    return wrap;
  }

  function readCount() {
    var el = document.querySelector('.cart-bubble__text-count') ||
             document.querySelector('.bl-announce__count') ||
             document.querySelector('[data-cart-count]');
    if (!el) return 0;
    var n = parseInt(String(el.textContent || '').replace(/[^0-9]/g, ''), 10);
    return isNaN(n) ? 0 : n;
  }

  var last = 0;
  var timer = null;

  function launch() {
    // The eagle badge itself takes the flight now; the count bubble is the
    // bird. Fall back to the old perched sprite only if the badge is absent.
    var bird = document.querySelector('.header-actions__cart-icon .cart-bubble') || mount();
    if (!bird) return;
    bird.classList.remove('is-flying');
    void bird.offsetWidth;
    bird.classList.add('is-flying');
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () { bird.classList.remove('is-flying'); }, 1250);
  }

  function sync(n) {
    var bird = mount();
    if (bird) bird.classList.toggle('is-perched', n > 0);
    // Horizon only stamps --has-cart server-side, so after an AJAX add the
    // class is stale. Keep it honest rather than hanging the bird off it.
    var icon = document.querySelector('.header-actions__cart-icon');
    if (icon) icon.classList.toggle('header-actions__cart-icon--has-cart', n > 0);
  }

  function check() {
    var n = readCount();
    if (n > last) launch();
    last = n;
    sync(n);
  }

  function start() {
    mount();
    last = readCount();
    sync(last);
    var targets = document.querySelectorAll('.cart-bubble__text-count, .bl-announce__count, [data-cart-count]');
    if (targets.length) {
      var obs = new MutationObserver(check);
      targets.forEach(function (t) {
        obs.observe(t, { childList: true, characterData: true, subtree: true });
      });
    }
    document.addEventListener('bl:cart:updated', check);
    document.addEventListener('bl:drawer:updated', check);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}());
/* ===== end BL_CART_BIRD ========================================== */

/* ---------------------------------------------------------------------------
   Cross-sell size picker: "Add" reveals the size chips for the pictured
   colorway; each chip is a normal [data-bl-add] so the existing add handler
   and drawer refresh take it from there. Delegated: the drawer re-renders.
--------------------------------------------------------------------------- */
(function () {
  document.addEventListener('click', function (e) {
    var pick = e.target.closest('[data-bl-pick]');
    if (!pick) return;
    e.preventDefault();
    var card = pick.closest('.bl-xs__card');
    if (!card) return;
    card.classList.add('is-picking');
    pick.setAttribute('aria-expanded', 'true');
    var sizes = card.querySelector('.bl-xs__sizes');
    if (sizes) {
      sizes.hidden = false;
      var first = sizes.querySelector('button');
      if (first) first.focus({ preventScroll: true });
    }
  });
})();

/* ---------------------------------------------------------------------------
   Add-to-cart nudge: the moment a size or color is chosen, the button lifts
   once (CSS .is-nudged). Delegated so it also covers Quick View and the
   sticky bar; one pulse per choice, never a loop.
--------------------------------------------------------------------------- */
(function () {
  function nudge(scope) {
    if (!scope) return;
    var btns = scope.querySelectorAll('.bl-pdp__atc, .bl-qv__atc, .bl-sticky__atc');
    if (!btns.length) btns = document.querySelectorAll('.bl-pdp__atc, .bl-sticky__atc');
    btns.forEach(function (b) {
      if (b.disabled) return;
      b.classList.remove('is-nudged');
      void b.offsetWidth;
      b.classList.add('is-nudged');
      clearTimeout(b.__blNudgeTimer);
      b.__blNudgeTimer = setTimeout(function () { b.classList.remove('is-nudged'); }, 1000);
    });
  }
  document.addEventListener('animationend', function (e) {
    if (e.animationName === 'bl-atc-nudge') e.target.classList.remove('is-nudged');
  });
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.type !== 'radio') return;
    var scope = input.closest('.bl-pdp, [data-bl-product], .bl-qv, form');
    if (!scope) return;
    if (!scope.querySelector('.bl-pdp__atc, .bl-qv__atc')) return;
    nudge(scope);
  });
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-bl-qv-kind], .bl-qv__chip');
    if (!sw) return;
    nudge(sw.closest('.bl-qv') || document);
  });
})();

/* ---------------------------------------------------------------------------
   Remembered size: the first size a shopper picks is kept in localStorage and
   pre-selected on every product page after that, as long as that size is in
   stock for the pictured color. A real `change` event is dispatched so the
   theme's own variant sync (price, URL, sticky bar) runs as if they tapped it.
--------------------------------------------------------------------------- */
(function () {
  var KEY = 'bl_size';
  function saved() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
  function store(v) { try { if (v) localStorage.setItem(KEY, v); } catch (e) {} }
  document.addEventListener('change', function (e) {
    var i = e.target;
    if (!i || i.type !== 'radio' || i.__blAuto) return;
    if (!i.closest('.bl-pdp__chips--sizes')) return;
    store(i.value);
  });
  document.addEventListener('click', function (e) {
    var qv = e.target.closest('[data-bl-qv-kind="size"]');
    if (qv) store(qv.getAttribute('data-bl-qv-val'));
  });
  function apply() {
    var fs = document.querySelector('.bl-pdp__chips--sizes');
    if (!fs) return;
    var want = saved();
    if (!want) return;
    var inputs = Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]'));
    var cur = inputs.filter(function (x) { return x.checked; })[0];
    if (cur && cur.value === want) return;
    var target = inputs.filter(function (x) {
      if (x.value !== want || x.disabled) return false;
      var label = x.closest('label');
      return !(label && /unavailable|sold-out|is-soldout/.test(label.className));
    })[0];
    if (!target) return;
    target.__blAuto = true;
    target.checked = true;
    target.dispatchEvent(new Event('change', { bubbles: true }));
    target.__blAuto = false;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
})();
